import React from 'react';
import { ArrowRight, Heart, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { videos, companyInfo } from '../data/mock';

const HeroSection = () => {
  return (
    <section id="home" className="hero-section py-12 lg:py-16" aria-label="Home Care Services Hero">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Text Content at Top - Centered */}
        <div className="text-center animate-fadeInUp mb-10">
          {/* Logo prominent display - BIGGER */}
          <div className="mb-6">
            <img 
              src={companyInfo.logo} 
              alt="A Gentle Touch HomeCare - Compassionate Non Medical Home Care Services in Columbus, Ohio" 
              className="h-72 sm:h-80 lg:h-[28rem] w-auto mx-auto"
              width="448"
              height="448"
            />
          </div>
          
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-display font-semibold leading-tight mb-4" style={{ color: '#c49bc4' }}>
            Compassionate Home Care for your Loved Ones
          </h1>
          
          <p className="text-lg sm:text-xl text-gray-600 mb-4" style={{ color: '#008080' }}>
            {companyInfo.tagline}
          </p>
          
          <p className="text-base sm:text-lg text-gray-600 mb-6 leading-relaxed max-w-2xl mx-auto">
            High quality, individualized non medical in home care and companionship services 
            for aging adults in Columbus, Ohio. Personal care, companion care, respite care, 
            and Alzheimer's & dementia care.
          </p>

          {/* Phone CTA Above Fold */}
          <div className="mb-6">
            <a 
              href="tel:+16149284169" 
              className="inline-flex items-center gap-2 text-xl font-semibold"
              style={{ color: '#008080' }}
            >
              <Phone className="w-5 h-5" aria-hidden="true" />
              Call Us: 614-928-4169
            </a>
          </div>
        </div>
        
        {/* Centered Video */}
        <div className="relative animate-fadeIn mb-10" style={{ animationDelay: '0.3s' }}>
          <div className="video-container aspect-video max-h-[500px] mx-auto rounded-2xl overflow-hidden">
            <video 
              autoPlay 
              muted 
              loop 
              playsInline
              preload="metadata"
              className="w-full h-full object-cover"
              width="800"
              height="450"
              aria-label="A Gentle Touch HomeCare promotional video showing compassionate senior care"
            >
              <source src={videos.hero} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          
          {/* Decorative elements */}
          <div className="absolute -bottom-6 -left-6 w-24 h-24 rounded-2xl bg-[#d9b3d9] opacity-30 -z-10" aria-hidden="true"></div>
          <div className="absolute -top-6 -right-6 w-32 h-32 rounded-full bg-[#c4a57e] opacity-20 -z-10" aria-hidden="true"></div>
        </div>
        
        {/* CTA Buttons Underneath Video - Centered */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fadeInUp" style={{ animationDelay: '0.5s' }}>
          <Link 
            to="/contact"
            className="btn-primary flex items-center justify-center gap-2 text-base px-8 py-4"
          >
            <Heart className="w-5 h-5" aria-hidden="true" />
            Request Care Consultation
            <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </Link>
          <Link 
            to="/apply"
            className="btn-secondary flex items-center justify-center gap-2 text-base px-8 py-4"
          >
            Apply to Work With Us
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
